// extracted by mini-css-extract-plugin
export default {"form":"CompanyUserModal_form__WjRDg","roleColumn":"CompanyUserModal_roleColumn__kKmqW"};